<h2 mat-dialog-title class="pb-0">Detalles</h2>

<mat-chip-set aria-label="ID" class="px-24">
    <mat-chip class="chip-info br-5">
        <strong>ID:</strong> {{ processId }}
    </mat-chip>
</mat-chip-set>

<mat-dialog-content class="mat-typography">
    <div *ngIf="isLoading; else content" class="data-loading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <ng-template #content>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="mr-2 text-success justify-content-end">check_circle</mat-icon>
                        Procesos ejecutados correctamente: {{ correctExecutions }}
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ng-container *ngIf="successFiles.length > 0; else noFiles">
                    <div class="d-flex flex-column w-100">
                        <a
                            *ngFor="let file of successFiles; index as i"
                            mat-button
                            color="primary"
                            [href]="file"
                            download>
                            <mat-icon>download</mat-icon>
                            Archivo {{ i + 1 }}
                        </a>
                    </div>
                </ng-container>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="mr-2 text-danger justify-content-end">error</mat-icon>
                        Procesos ejecutados erróneamente: {{ errorExecutions }}
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ng-container *ngIf="errorFiles.length > 0; else noFiles">
                    <div class="d-flex flex-column w-100">
                        <a
                            *ngFor="let file of errorFiles; index as i"
                            mat-button
                            color="primary"
                            [href]="file"
                            download>
                            <mat-icon>download</mat-icon>
                            Archivo {{ i + 1 }}
                        </a>
                    </div>
                </ng-container>
            </mat-expansion-panel>
        </mat-accordion>

        <ng-template #noFiles>
            <p class="px-5">No hay archivos para descargar.</p>
        </ng-template>
    </ng-template>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button class="custom-button-basic" mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
